(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (function () {
    function moveKiwiAboveSizePicker() {
      var kiwi = document.querySelector('.ks-chart-modal-link');
      if (!kiwi) return false;

      // Find the Size fieldset by locating radio inputs whose name starts with "Size-"
      var sizeFieldset = null;
      var inputs = document.querySelectorAll('variant-picker input[type="radio"]');
      for (var i = 0; i < inputs.length; i++) {
        if ((inputs[i].name || '').split('-')[0].toLowerCase() === 'size') {
          sizeFieldset = inputs[i].closest('fieldset');
          break;
        }
      }

      // Fall back to the whole variant-picker if no size fieldset found
      var target = sizeFieldset || document.querySelector('variant-picker');
      if (!target) return false;

      var kiwiWrapper = kiwi.parentElement;
      if (kiwiWrapper && !target.contains(kiwiWrapper)) {
        target.parentNode.insertBefore(kiwiWrapper, target);
      }
      return true;
    }

    if (!moveKiwiAboveSizePicker()) {
      var observer = new MutationObserver(function () {
        if (moveKiwiAboveSizePicker()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  })();

  (function () {
    function moveRatingAfterPrice() {
      var rating = document.querySelector('.rating-wrapper-reviews');
      var price = document.querySelector('product-price[data-block-id="price_a7krng"]');
      if (!rating || !price) return false;
      price.insertAdjacentElement('afterend', rating);
      return true;
    }

    if (!moveRatingAfterPrice()) {
      var ratingObserver = new MutationObserver(function () {
        if (moveRatingAfterPrice()) ratingObserver.disconnect();
      });
      ratingObserver.observe(document.body, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
